import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'batch-import-loading',
  templateUrl: './batch-import-loading.component.html',
  styleUrls: ['./batch-import-loading.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BatchImportLoadingComponent {
  @Input() public currentProgress: string;

  constructor() {}
}
